<div class="container-fluid" *ngIf="dashboardJson">
  <div class="row mt-4">
    <div class="col-12">
      <h1 class="fb-dashboard-title" [ngClass]="{'capitalize': dashboardTemplate === 'employee'}">{{ dashboardJson.title
        }}</h1>
    </div>
  </div>
  <ng-container *ngFor="let layout of dashboardJson.layoutData">
    <ng-container *ngTemplateOutlet="recursiveLayout; context: { $implicit: layout }"></ng-container>
  </ng-container>
</div>

<ng-template #recursiveLayout let-element>
  <ng-container *ngIf="element.type === 'row'; else columnBlock">
    <div class="row" [ngClass]="element.customClass || ''">
      <ng-container *ngFor="let child of element.children">
        <ng-container *ngTemplateOutlet="recursiveLayout; context: { $implicit: child }"></ng-container>
      </ng-container>
    </div>
  </ng-container>

  <ng-template #columnBlock>
    <div [class]="'col-' + element.size" [ngClass]="element.customClass || ''">
      <ng-container *ngIf="element.children; else contentBlock">
        <ng-container *ngFor="let child of element.children">
          <ng-container *ngTemplateOutlet="recursiveLayout; context: { $implicit: child }"></ng-container>
        </ng-container>
      </ng-container>
      <ng-template #contentBlock>
        <ng-container *ngIf="element.content">
          <ng-container [ngSwitch]="element.content.type">
            <ng-container *ngSwitchCase="'small_tile'">
              <div class="full-height"
                [ngStyle]="{'background-color': element.content.borderRadius ? 'rgba(0,0,0,0)': '#ffffff', 'border-radius': element.content.borderRadius ? element.content.borderRadius : '0px', 'box-shadow': element.content.borderRadius ? 'none': '0px 2px 6px rgba(0, 0, 0, 0.4)'}">
                <app-fb-dashboard-small-tiles class="w-100" [content]="element.content"></app-fb-dashboard-small-tiles>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'leave_approval_tile'">
              <div class="full-height">
                <app-fb-leave-approval-status-dashboard-card class="w-100"
                  [content]="element.content"></app-fb-leave-approval-status-dashboard-card>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'summary_tile'">
              <div class="full-height">
                <app-fb-summary-status-dasboard-card class="w-100"
                  [content]="element.content"></app-fb-summary-status-dasboard-card>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'notification_tile'">
              <div class="full-height">
                <app-fb-notifications-dashboard-card class="w-100"
                  [content]="element.content"></app-fb-notifications-dashboard-card>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'chart_tile'">
              <div class="full-height">
                <app-fb-margin-growth-card class="w-100" [content]="element.content"></app-fb-margin-growth-card>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'announcement_tile'">
              <div class="full-height">
                <app-fb-announcements-dashboard-card class="w-100"
                  [content]="element.content"></app-fb-announcements-dashboard-card>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'team_members_tile'">
              <div class="full-height">
                <app-fb-team-members-dashboard-card class="w-100" [content]="element.content"
                  (teamMembersCountChange)="handleTeamMembersCountChange($event)"></app-fb-team-members-dashboard-card>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'holiday_list_tile'">
              <div class="full-height">
                <app-fb-holiday-list-dashboard-card class="w-100"
                  [content]="element.content"></app-fb-holiday-list-dashboard-card>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'table_tile'">
              <div class="full-height">
                <app-fb-table-list-dashboard-card class="w-100"
                  [content]="element.content"></app-fb-table-list-dashboard-card>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'onboarding_checklist_tile'">
              <div class="full-height">
                <app-fb-onboarding-checklist-dashboard-card class="w-100"
                  [content]="element.content"></app-fb-onboarding-checklist-dashboard-card>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'coming_soon'">
              <div class="full-height">
                <app-fb-coming-soon-dashboard-card class="w-100"
                  [content]="element.content"></app-fb-coming-soon-dashboard-card>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'attendence_details'">
              <div class="full-height">
                <app-fb-attendence-dashboard-card class="w-100"></app-fb-attendence-dashboard-card>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'quick_access'">
              <div class="full-height">
                <app-fb-dashboard-quick-access class="w-100"
                  [content]="element.content"></app-fb-dashboard-quick-access>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-template>
    </div>
  </ng-template>
</ng-template>